import { call, put, takeLatest } from "redux-saga/effects";
import request from "utils/request";
import { creatorsActions } from "./index";
import { showToast } from "components/ToastContainer/index";

function* fetchCreatorsList(action) {
  try {
    const {
      page = 1,
      limit = 10,
      state,
      city,
      company,
      managed_by,
      from_date,
      to_date,
      period,
      search,
      search_field
    } = action.payload || {};

    const queryParams = new URLSearchParams({ page, limit });
    if (state) queryParams.append("state", state);
    if (city) queryParams.append("city", city);
    if (company) queryParams.append("company", company);
    if (managed_by) queryParams.append("managed_by", managed_by);
    if (from_date) queryParams.append("from_date", from_date);
    if (to_date) queryParams.append("to_date", to_date);
    if (period) queryParams.append("period", period);
    if (search) queryParams.append("search", search);
    if (search_field) queryParams.append("search_field", search_field);

    const data = yield call(
      request,
      `/api/get-creators?${queryParams.toString()}`,
      { method: "GET", credentials: "include" }
    );

    yield put(creatorsActions.fetchCreatorsSuccess(data));
  } catch (error) {
    yield put(creatorsActions.fetchCreatorsFailure(error.message));
  }
}

export function* creatorsSaga() {
  yield takeLatest(creatorsActions.fetchCreators.type, fetchCreatorsList);
}
